import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['download']

  handleDownload(e) {
    e.preventDefault()
    const form = $('#filterific_filter_custom')
    const href = $(this.downloadTarget).find('a').attr('href')
    const symbol = $(this.downloadTarget).data('symbol') // ? or &

    window.open(`${href}${symbol}${form.serialize()}`)
  }
}